import _ from 'lodash';

import { Job } from '@app/types/api/job';
import { InboxFilters } from '@app/types/reducer-state';

export const addUnreadMessageIndication = ({ jobs } : { jobs: Job[] }) => _(jobs)
  .map((job) => {
    const hasUnreadMessages = (job.unreadMessageCount ?? 0) > 0;
    return { ...job, hasUnreadMessages };
  })
  .value();

export const stub = () => {};

export const restOfFiltersOriginal = (inboxFilters: InboxFilters) => {
  if (
    (inboxFilters?.operatorIds
      && Object.keys(inboxFilters.operatorIds).length > 0)
    || (inboxFilters?.groups && Object.keys(inboxFilters.groups).length > 0)
    || !inboxFilters?.items?.myChats
    || !inboxFilters?.items?.secondaryOperatorIds
    || inboxFilters?.items?.unassigned
  ) {
    return false;
  }
  return true;
};

export const FILTER_OPTIONS = {
  0: {
    refineBy: null,
    tags: ['all'],
    operatorIds: {},
    groups: {},
    items: {
      myChats: '',
      secondaryOperatorIds: 'My Secondary Assignments',
    },
  },
  1: {
    refineBy: 'unansweredOptIns',
    tags: ['all'],
    operatorIds: {},
    groups: {},
    items: {
      myChats: '',
      secondaryOperatorIds: 'My Secondary Assignments',
    },
  },
  2: {
    refineBy: null,
    tags: ['needs-attention', 'has-question'],
    operatorIds: {},
    groups: {},
    items: {
      myChats: '',
      secondaryOperatorIds: 'My Secondary Assignments',
    },
  },
  3: {
    refineBy: null,
    tags: [],
  },
};

export const containsTags = (arr1: string[], arr2: string[]) => arr1?.length === arr2?.length
  && arr1?.every((value) => arr2?.includes(value));

export const getPreSelectedFilterType = (inboxFilters: InboxFilters) => {
  if (!restOfFiltersOriginal(inboxFilters)) {
    return FILTER_OPTIONS[3];
  }
  if (
    containsTags(FILTER_OPTIONS[0].tags, inboxFilters?.tags || [])
    || !inboxFilters?.tags
    || inboxFilters?.tags?.length === 0
  ) {
    if (
      inboxFilters?.refineBy === FILTER_OPTIONS[0].refineBy
      && inboxFilters?.items?.myChats
      && inboxFilters?.items?.secondaryOperatorIds === 'My Secondary Assignments'
    ) {
      return FILTER_OPTIONS[0];
    }
    if (inboxFilters?.refineBy === FILTER_OPTIONS[1].refineBy) {
      return FILTER_OPTIONS[1];
    }
  }
  if (
    containsTags(FILTER_OPTIONS[2].tags, inboxFilters?.tags || [])
    && inboxFilters?.refineBy === FILTER_OPTIONS[2].refineBy
  ) {
    return FILTER_OPTIONS[2];
  }
  return FILTER_OPTIONS[3];
};
